// extracted by mini-css-extract-plugin
module.exports = {"simpleCard":"TabArtist_simpleCard__nunHm","simpleCardActive":"TabArtist_simpleCardActive__DjAny","simpleCardHover":"TabArtist_simpleCardHover___ao_j"};